module.exports = {"data":{"site":{"siteMetadata":{"title":"Maxime Beaudoin Front-End Developer from Montr&eacute;al"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 116
// module chunks = 60335399758886 114276838955818